<template>
    <div class="navbar navbar-dark d-block bg-dark text-white position-fixed h-100 align-self-start w-sidebar p-0 pt-2 pb-4 text-uppercase" id="sidebar">
        <button data-toggle="collapse" data-target=".sidebar-collapse" class="navbar-brand my-1 mr-3 float-right py-0 px-1 bg-primary d-inline-block d-lg-none btn btn-link">
          <span class="h4 align-middle mb-0"><span class="lnr lnr-menu shadow-sm"></span></span>
        </button>
        <div class="nav flex-column flex-wrap pt-5 mt-3" id="menu1">
            <div class="collapse show" data-parent="#sidebar" id="demo1">
                <div class="nav pb-2 flex-column flex-wrap text-truncate">
                    <template v-for="(link,index) in sidebarLinks">
                      <router-link v-if="link.children" v-bind:key="index" :to="link.path" :ref="link.name" class="nav-link text-nowrap ripple" aria-expanded="false" :title="link.name" :class="[link.children ? '' : '', linkClass]" 
                      data-toggle="collapse" :data-target="'#menu'+index">
                          <i :class="[link.icon, iconClasses]"></i>
                          <span :class="textLinkClass">{{ link.name }}</span>
                      </router-link>
                      <div class="collapse" :class="index===0?'show':''" :id="'menu'+index" v-bind:key="index" data-parent="#menu1">
                          <router-link v-for="(child,i) in link.children" class="nav-link text-nowrap" :title="child.name" :class="childLinkClass" :to="child.path" :key="i">
                              <i :class="[child.icon, iconClasses]" v-if="child.icon"></i>
                              <span :class="textLinkClass">{{ child.name }}</span>
                          </router-link>
                      </div>
                      <router-link v-if="!link.children" v-bind:key="index" :to="link.path" :ref="link.name" class="nav-link text-nowrap ripple" :title="link.name" :class="linkClass" 
                       data-parent="#menu1">
                          <i :class="[link.icon, iconClasses]"></i>
                          <span :class="textLinkClass">{{ link.name }}</span>
                      </router-link>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
      sidebarClasses: {
        type: String,
        default: 'navbar-expand-md flex-md-column align-items-start navbar-dark bg-dark',
      },
      navClasses: {
        type: String,
        default: 'flex-column flex-wrap mx-auto mx-md-0 w-100',
      },
      iconClasses: {
        type: String,
        default: 'align-middle mr-2',
      },
      sidebarLinks: {
        type: Array,
        default: () => []
      },
      textLinkClass: {
        type: String,
        default: 'text-truncate align-middle',
      },
      linkClass: {
        type: String,
        default: '',
      },
      childLinkClass: {
        type: String,
        default: '',
      },
      defaultIcon: {
        type: String,
        default: 'chevron_right',
      },
      showBrand: {
        type: Boolean,
        default: true
      },
      showToggler: {
        type: Boolean,
        default: false
      },
      showArrow: {
        type: Boolean,
        default: false
      },
      arrowClass: {
        type: String,
        default: 'd-none d-md-inline-block',
      },
      arrowOffset: {
        type: Number,
        default: 60,
      }
    },
    components: {
      //arrow
    },
    computed: {
      arrowMove () {
        return this.linkHeight * this.activeLinkIndex;
      }
    },
    data() {
      return {
        linkHeight: 40,
        activeLinkIndex: 0
      };
    },
    methods: {
      setActiveLink () {
        this.sidebarLinks.find((element, index) => {
          let found = element.path === this.$route.path;
          if (found) {
            this.activeLinkIndex = index;
            return found;
          }
        });
      }
    },
    mounted() {
      this.setActiveLink();
    },
    watch: {
      $route: function () {
        this.setActiveLink();
      }
    }
};
</script>
